import { Controller } from "@hotwired/stimulus"

// Dispatche un CustomEvent sur document puis se retire du DOM.
// Remplace les <script> inline dans les réponses Turbo Stream.
//
// Usage :
// <div data-controller="event-dispatch"
//      data-event-dispatch-event-name-value="module:created"
//      data-event-dispatch-detail-value='{"id":1,"name":"Module"}'>
// </div>
export default class extends Controller {
  static values = {
    eventName: String,
    detail: { type: Object, default: {} }
  }

  connect() {
    if (!this.eventNameValue) return

    document.dispatchEvent(
      new CustomEvent(this.eventNameValue, { detail: this.detailValue })
    )

    this.element.remove()
  }
}
